/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since  2017.9.8
 */
import './polyfill/ToolTip';
import './polyfill/Renderer';
import './polyfill/L.CanvasLayer';

//
import 'leaflet-path-drag';
import 'leaflet-path-transform';//点旋转 dashArray 有点问题。
//
import './polyfill/Editable';
// 涉及重写Polyline 的 onAdd 和 flow 有顺序执行的冲突
// import '@/plugins/meature/leaflet-measure-path';
// import '@/plugins/meature/leaflet-measure-path.css';
// 聚合点
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
// 添加shp文件
import './polyfill/Shp';
// 


// WEBPACK FOOTER //
// ./src/Polyfill.js